import { render, staticRenderFns } from "./NaviEntryPlans.vue?vue&type=template&id=2b08a88f&"
import script from "./NaviEntryPlans.vue?vue&type=script&lang=ts&"
export * from "./NaviEntryPlans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports